import React, { useState } from "react";
import { Button, HStack, Input } from "@chakra-ui/react";
import { FiZap } from "react-icons/fi";
import { useAtom } from "jotai";
import { tokenFetchingState } from "./store";

export default function InputAddress({ defaultValue }) {
  let [address, setAddress] = useState(defaultValue);
  let [fetchState, doFetch] = useAtom(tokenFetchingState)

  return (
    <HStack spacing={4}>
      <Input value={address} onChange={(e) => setAddress(e.target.value)} />
      <Button
        variant="brand"
        leftIcon={<FiZap />}
        isLoading={fetchState.isLoading}
        onClick={() => doFetch(address)}
      >
        Audit
      </Button>
    </HStack>
  );
}
